import React from 'react';
import { Clock, Users, Utensils, Leaf, Award } from 'lucide-react';

const Features = () => {
  const features = [
    {
      id: 1,
      icon: Clock,
      title: "Lunch & Dinner Service",
      description: "Open Tuesday to Sunday"
    },
    {
      id: 2,
      icon: Award,
      title: "Cosy & Trendy Atmosphere",
      description: "Perfect for casual dining"
    },
    {
      id: 3,
      icon: Users,
      title: "Ideal for Groups",
      description: "Popular with students & locals"
    },
    {
      id: 4,
      icon: Leaf,
      title: "Vegetarian & Meat Options",
      description: "Diverse menu selection"
    },
    {
      id: 5,
      icon: Utensils,
      title: "Authentic Korean Cuisine",
      description: "Traditional recipes & flavors"
    }
  ];

  return (
    <section className="features-section">
      <div className="features-container">
        <h2 className="section-title">Dining Experience</h2>
        
        <div className="features-grid">
          {features.map((feature) => {
            const Icon = feature.icon;
            return (
              <div key={feature.id} className="feature-card">
                <div className="feature-icon">
                  <Icon className="w-8 h-8" strokeWidth={1.5} />
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
